import './style.scss';

import { Button } from '@components/Button/Button';
import { Spin } from 'antd';
import _ from 'lodash';
import { ReactNode } from 'react';
import { useNavigate } from 'react-router';

import { useGetMeQuery } from '@/api/auth/api';
import { hasPermission, securityConfig } from '@/shared/security/hasPermission';

interface SecuredProps {
  children: ReactNode | ((permitted: boolean) => ReactNode);
  security?: securityConfig;
  fallback?: ReactNode | string;
  showButton?: boolean;
}

export const Secured = ({
  children,
  security,
  fallback = 'Доступ на страницу невозможен',
  showButton = true,
}: SecuredProps) => {
  const navigate = useNavigate();
  const { data: user, isLoading } = useGetMeQuery();

  if (isLoading) {
    return (
      <div className="secured">
        <Spin size="large" />
      </div>
    );
  }
  const permitted = hasPermission(user.auth, security);

  if (_.isFunction(children)) {
    return children(permitted);
  }

  if (permitted) {
    return children;
  }

  return (
    <div className="secured">
      {fallback}
      {showButton && (
        <Button text="На главную" type="primary" action={() => navigate('/')} />
      )}
    </div>
  );
};
